import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { TruncatedText } from "@/components/ui/truncated-text";

interface UnviewedIndicatorTextProps {
  indicatorText: string;
  primaryText: string;
  showIndicatorText: boolean;
}

export const UnviewedIndicatorText = ({
  indicatorText,
  primaryText,
  showIndicatorText,
}: UnviewedIndicatorTextProps) => {
  const sharedClassNames = useMemo(
    () => twMerge(["text-uw-purple", showIndicatorText && "font-bold"]),
    [showIndicatorText],
  );

  return (
    <Flex justify="space-between">
      {/* Shorter max length than default to leave room for the indicator */}
      <TruncatedText
        maxLength={showIndicatorText ? 40 : undefined}
        textElProps={{
          className: twMerge([
            "text-sm",
            showIndicatorText && "mr-3",
            sharedClassNames,
          ]),
        }}
        value={primaryText}
      />
      {showIndicatorText && (
        <Flex
          className={twMerge([
            sharedClassNames,
            "bg-[#EFEAFA]",
            "px-2",
            "py-0.5",
            "rounded-full",
            "text-xs",
            "min-w-8",
          ])}
          justify="center"
        >
          {indicatorText}
        </Flex>
      )}
    </Flex>
  );
};
